export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6349.493eaa17.jpg";